module.exports = __webpack_public_path__ + "static/media/table_background_med.9771cb06.jpg";